function dec2hex(dec: number): string {
  return dec.toString(16).padStart(2, '0');
}

export function generateRandomString(length: number = 8): string {
  const randomArray = new Uint8Array(length / 2);
  window.crypto.getRandomValues(randomArray);

  return Array.from(randomArray, dec2hex).join('');
}
